var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_718_26694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7041 0C7.69915 0 2 5.69915 2 12.7041C2 19.7091 7.69915 25.4082 14.7041 25.4082C21.7091 25.4082 27.4082 19.7091 27.4082 12.7041C27.4082 5.69915 21.709 0 14.7041 0Z",
    fill: "#329DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5862 7.72585L19.6823 9.82192L11.822 17.6822L9.72594 15.5861L17.5862 7.72585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6823 15.5861L17.5862 17.6822L9.72594 9.82192L11.822 7.72585L19.6823 15.5861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_718_26694",
    x: 0,
    y: 0,
    width: 29.4082,
    height: 29.4082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_718_26694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_718_26694",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelAddress);
export default __webpack_public_path__ + "static/media/del_address.b98fac62af1754eec991bd10a24f4c3d.svg";
export { ForwardRef as ReactComponent };